module.exports = __webpack_public_path__ + "img/jiaoyu_xianjiaoda_suoluetu.62b70029.jpeg";